import Collection from  './base';
import Category from '../models/category';

export default Collection.extend( {
	model: Category,

	comparator: 'name',
} );
